import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable()
export class DataProvider {
  // Data Provider
  // This is the provider class for most of the Firebase observables in the app.

  constructor(public angularfire: AngularFireDatabase) {}

  getTimeStamp() {
    return firebase.database.ServerValue.TIMESTAMP;
  }

  /**
   * Obtiene el nodo /users/{used_id}
   */
  getUser(team, userId) {
    const ret = this.angularfire.object(`${team}/users/${userId}`);
    // console.log(`getUser() -> ${JSON.stringify(ret)}`);
    return ret;
  }

  /**
   * Obtiene el nodo de messagesDeleted de una conversación individual y de un usuario uid.
   */
  getConversationMessagesDeleted(team, conversId, uid) {
    const ret =
      this.angularfire.object(`${team}/conversations/${conversId}/messagesDeleted/${uid}`);
    // console.log(`getConversationMessagesDeleted() -> ${JSON.stringify(ret)}`);
    return ret;
  }

   /**
   * Obtiene el nodo de messagesRead de una conversación individual y de un usuario uid.
   */
  getConversationMessagesRead(team, conversationType, conversationId, uid) {
    const ret =
      this.angularfire.object(`${team}/${conversationType}/${conversationId}/messagesRead/${uid}`);
    // console.log(`getConversationMessagesRead() -> ${JSON.stringify(ret)}`);
    return ret;
  }

  /**
   * Obtiene el nodo de una conversación individual y de un usuario uid.
   */
  getConversation(team, conversationType, groupId) {
    const ret = this.angularfire.object(`${team}/${conversationType}/${groupId}`);
    // console.log(`get${conversationType}() -> ${JSON.stringify(ret)}`);
    return ret;
  }

  /**
   * Obtiene el nodo del listado de mensajes para poder hacer CRUD.
   */
  getConversationMessagesList(team, conversationType, conversationId) {
    const ret = this.angularfire.list(`${team}/${conversationType}/${conversationId}/messages`);
    console.log('conversationsssss', ret);
    
    // console.log(`getConversationMessagesList() -> ${JSON.stringify(ret)}`);
    return ret;
  }

  /**
   * Obtiene el nodo del ultima conexion para poder hacer CRUD.
   */
  getConversationLastDate(team, conversationType, conversationId) {
    return this.angularfire.object(`${team}/${conversationType}/${conversationId}/lastDate`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/data.ts